import { configureStore } from "@reduxjs/toolkit";
import filtersReducer from "./Slices/filterSlice";

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
  },
});

export default store;
